module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "main-content container-fluid"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-xs-12"
  }, [_vm._c('Panel', {
    staticClass: "panel panel-default panel-border-color panel-border-color-primary"
  }, [_vm._c('PanelBody', [_vm._c('div', {
    staticClass: "processing"
  }, [_vm._c('div', {
    staticClass: "icon"
  }, [_vm._c('img', {
    attrs: {
      "src": "/static/img/logo-icon.png"
    }
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "text"
  }, [_vm._c('h2', [_vm._v("Processing" + _vm._s(_vm.message))]), _vm._v(" "), _vm._c('p', [_vm._v("\n                Your file is being processed. Please "), _vm._c('strong', [_vm._v("do not refresh this page")]), _vm._v("."), _vm._c('br'), _vm._v("\n                You will be redirected shortly to create your lecture notes.\n              ")])])])])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-475fb218!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/file-importer/FileProcessing.vue
// module id = 655
// module chunks = 1